import learningHubTheme from './learningHubTheme';
import NdsThemeProviderBaseHoc from './NdsThemeProviderBaseHoc';
const NdsThemeProviderLearningHub = NdsThemeProviderBaseHoc(learningHubTheme);
export { NdsThemeProviderLearningHub as NdsThemeProviderRootComp };
export default NdsThemeProviderLearningHub;
//# sourceMappingURL=NdsThemeProviderLearningHub.js.map